if (!customElements.get('iron-blog-filters')) {
  class IronBlogFilters extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.form = this.querySelector('form');
      this.searchInput = this.querySelector('[data-iron-blog-search]');
      this.categorySelect = this.querySelector('[data-iron-blog-category]');

      this.categorySelect?.addEventListener('change', () => this.goTo(this.categorySelect.value));
      this.form?.addEventListener('submit', (event) => this.handleSubmit(event));
    }

    handleSubmit(event) {
      if (this.searchInput?.value.trim()) return;

      event.preventDefault();
      this.goTo(this.categorySelect?.value || this.dataset.blogUrl);
    }

    goTo(url) {
      if (url && url !== window.location.pathname) window.location.assign(url);
    }
  }

  customElements.define('iron-blog-filters', IronBlogFilters);
}
